// src/services/contentPagesServices.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  CONTENT_PAGES_LIST,
  CONTENT_PAGES_ADD,
  CONTENT_PAGES_UPDATE,
  CONTENT_PAGES_DELETE,
} from "../../config/constants"; // Adjust endpoints as per your config

const contentPagesServices = createApi({
  reducerPath: "contentPagesServices",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["ContentPage"],
  endpoints: (builder) => ({
    getContentPages: builder.query({
      query: (bodyData) => ({
        url: CONTENT_PAGES_LIST, // Endpoint to fetch ingredient list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["ContentPage"],
    }),
    addContentPage: builder.mutation({
      query: (ingredientData) => ({
        url: CONTENT_PAGES_ADD, // Endpoint to add a ingredient
        method: "POST",
        data: ingredientData, // ContentPage data for the request body
      }),
      invalidatesTags: ["ContentPage"],
    }),
    updateContentPage: builder.mutation({
      query: ({ ingredientId, updatedData }) => ({
        url: `${CONTENT_PAGES_UPDATE}/${ingredientId}`, // Endpoint to update a ingredient
        method: "PUT",
        data: updatedData, // Updated ingredient data
      }),
      invalidatesTags: ["ContentPage"],
    }),
    deleteContentPage: builder.mutation({
      query: (ingredientId) => ({
        url: `${CONTENT_PAGES_DELETE}/${ingredientId}`, // Endpoint to delete a ingredient
        method: "DELETE",
      }),
      invalidatesTags: ["ContentPage"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetContentPagesQuery,
  useAddContentPageMutation,
  useUpdateContentPageMutation,
  useDeleteContentPageMutation,
} = contentPagesServices;

// Export the reducer to be included in the store
export default contentPagesServices;
